export enum ListBulkAction {
    Append = 'append',
    Remove = 'remove',
    Sync = 'sync'
}

export enum ListSearchAction {
    IndividualProductPack = 'individualProductPack',
    MedicinalProduct = 'medicinalProduct',
    PoisonSchedule = 'poisonSchedule',
    AtcCode = 'atcCode'
}
